export default class Mixpanel {
  constructor() {
    this.hasMixpanel = typeof window.mixpanel !== 'undefined'
  }

  track(name, props) {
    try {
      if (this.hasMixpanel) {
        mixpanel.track(name, props)
      }
    } catch (e) {
      console.error(e)
    }
  }

  getRequestParams() {
    const q = window.location.search.substring(1)
    let params = {}
    $.each(q.split('&'), function(i, val) {
      const buf = val.split('=')
      if (buf.length === 1) {
        params[buf[0]] = true
      } else if (buf.length === 2) {
        params[buf[0]] = buf[1]
      }
    })
    return params
  }

  getParam(name, callback) {
    const params = this.getRequestParams(),
      value = params[name]
    if (typeof value !== 'undefined') {
      callback(value)
    }
  }

  trackSignup(method, props) {
    let pageName = this.getPageName()
    this.track(
      'Sign Up Start',
      $.extend(props || {}, {
        'Signup Method': method,
        'Signup Entry Point': pageName,
        'Design Type': '201707',
      }),
    )
    if (mixpanel.nulab) {
      mixpanel.nulab.track('[Cacoo] Sign Up Start', {
        'Signup Entry Point': pageName,
      })
    }
  }

  getPageName() {
    var pageNames = {
      home: 'Home',
      templates: 'Templates',
      contact: 'Contact',
      pricing: 'Pricing',
      plus: 'Plus',
      'plus/try': 'Plus Signup',
      team: 'Team',
      'visio-alternative': 'Visio',
      education: 'Education',
      'education/apply': 'Education Signup',
      'team/try': 'Team Signup',
      signup: 'Free Signup',
      'invitations/signup': 'Invitation Signup',
      'invitations/signin': 'Invitation Signin',
      integrations: 'Integrations',
      'integrations/dropbox': 'Integrations - Dropbox',
      'integrations/boxcom': 'Integrations - Box.com',
      'integrations/adobe': 'Integrations - Adobe Creative Cloud',
      'integrations/googledrive': 'Integrations - Google Drive',
      'integrations/confluence': 'Integrations - Confluence',
      customer: 'Customer Landing Page',
      'customers/dmm': 'Customer - DMM',
      'customers/cookpad': 'Customer - Cookpad',
      'customers/cinra': 'Customer - CINRA',
      'customers/cloudpack': 'Customer - Cloudpak',
      'customers/giftee': 'Customer - Giftee',
    }
    var pageName = pageNames[Cacoo.settings.pagename]
    if (typeof pageName === 'undefined') {
      pageName = Cacoo.settings.pagename
    }
    return pageName
  }

  bindTeamCTA() {
    const pageName = this.getPageName()
    const $ctaButton = $('.js_mp_team_cta')
    if (pageName !== 'Team') {
      return
    }

    $ctaButton.on('click', (e) => {
      let entryPoint = ''

      let $target = $(e.target)
      if ($target.hasClass('js_mp_button_main')) {
        entryPoint = 'Main'
      } else {
        entryPoint = $target.attr('data-mp')
      }
      this.track('Clicked Team CTA', {
        'CTA Position':
          entryPoint !== '' ? pageName + ' - ' + entryPoint : pageName,
      })
    })
  }
}
